// @copyright  2006-2022 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: 'memos/archive',
        component: () =>
            import(/* webpackChunkName: "human-resource.team-member-memos" */ '@/pages/[organisation]/hr/team-member-memos/archived-team-member-memos.vue'),
        name: 'human-resource.team-member-memos.archived-team-member-memos',
        meta: {
            loginRequired: true,
            permission: 'access.human-resource.memo.update-team-member-memo',
        },
    },
    {
        path: 'memos/archive/:memoId',
        component: () =>
            import(/* webpackChunkName: "human-resource.team-member-memos" */ '@/pages/[organisation]/hr/team-member-memos/archived-team-member-memo/[id].vue'),
        name: 'human-resource.team-member-memos.view-archived-team-member-memo',
        meta: {
            loginRequired: true,
            permission: 'access.human-resource.memo.update-team-member-memo',
        },
    },

    {
        path: 'memos',
        component: () =>
            import(/* webpackChunkName: "human-resource.team-member-memos" */ '@/pages/[organisation]/hr/team-member-memos/team-member-memos.vue'),
        name: 'human-resource.team-member-memos.search-team-member-memos',
        meta: {
            loginRequired: true,
            permission: 'access.human-resource.memo.view-team-member-memos',
        },
    },
    {
        path: 'memos/new',
        component: () =>
            import(/* webpackChunkName: "human-resource.team-member-memos" */ '@/pages/[organisation]/hr/team-member-memos/team-member-memo/new.vue'),
        name: 'human-resource.team-member-memos.create-team-member-memo',
        meta: {
            loginRequired: true,
            permission: 'access.human-resource.memo.create-team-member-memo',
        },
    },
    {
        path: 'memos/:memoId',
        component: () =>
            import(/* webpackChunkName: "human-resource.team-member-memos" */ '@/pages/[organisation]/hr/team-member-memos/team-member-memo/[id].vue'),
        name: 'human-resource.team-member-memos.view-team-member-memo',
        meta: {
            loginRequired: true,
            permission: 'access.human-resource.memo.view-team-member-memos',
        },
    },
    {
        path: 'memos/:memoId/edit',
        component: () =>
            import(/* webpackChunkName: "human-resource.team-member-memos" */ '@/pages/[organisation]/hr/team-member-memos/team-member-memo/[id]/edit.vue'),
        name: 'human-resource.team-member-memos.update-team-member-memo',
        meta: {
            loginRequired: true,
            permission: 'access.human-resource.memo.update-team-member-memo',
        },
    },
];
